/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PurchaseOrderDto as DigiworkMaitreDPosDtoPurchesOrdersPurchaseOrderDto } from '../../models/Digiwork/MaitreD/Pos/DTO/PurchesOrders/purchase-order-dto';
import { ReceivePurchaseOrderDto as DigiworkMaitreDPosDtoPurchesOrdersReceivePurchaseOrderDto } from '../../models/Digiwork/MaitreD/Pos/DTO/PurchesOrders/receive-purchase-order-dto';

export interface ReceivePurchaseOrder$Params {
  inventoryId: string;
  purchaseOrderId: string;
      body?: DigiworkMaitreDPosDtoPurchesOrdersReceivePurchaseOrderDto
}

export function receivePurchaseOrder(http: HttpClient, rootUrl: string, params: ReceivePurchaseOrder$Params, context?: HttpContext): Observable<StrictHttpResponse<DigiworkMaitreDPosDtoPurchesOrdersPurchaseOrderDto>> {
  const rb = new RequestBuilder(rootUrl, receivePurchaseOrder.PATH, 'post');
  if (params) {
    rb.path('inventoryId', params.inventoryId, {});
    rb.path('purchaseOrderId', params.purchaseOrderId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DigiworkMaitreDPosDtoPurchesOrdersPurchaseOrderDto>;
    })
  );
}

receivePurchaseOrder.PATH = '/api/inventories/{inventoryId}/purchase-orders/{purchaseOrderId}';
